module.exports = __webpack_public_path__ + "static/media/confirm.7097ffba.svg";